export default "/images/layout-1.jpg?d6de7ba6b07c5ee179f2742216ae726e";